import React from 'react';
import { Shield, Clock, TrendingDown, Zap, Droplets, Gauge } from 'lucide-react';
export function BenefitsSection() {
  return <section className="py-20 bg-white" data-id="element-307">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-308">
        <div className="text-center mb-12" data-id="element-309">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-310">
            Why Contractors Choose Precision Pro Sprayers
          </h2>
          <p className="text-xl text-gray-600" data-id="element-311">
            Designed to eliminate hauling, reduce downtime, and speed up every
            job.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-312">
          {/* Top Row - Outcome-Focused */}
          <div className="flex items-start space-x-4 p-6 bg-brand-light rounded-lg border border-gray-200" data-id="element-313">
            <div className="flex-shrink-0" data-id="element-314">
              <div className="w-12 h-12 bg-brand-yellow/10 rounded-full flex items-center justify-center" data-id="element-315">
                <Shield className="h-6 w-6 text-brand-yellow" data-id="element-316" />
              </div>
            </div>
            <div data-id="element-317">
              <h3 className="text-xl font-bold text-brand-dark mb-2" data-id="element-318">
                Stay Safe
              </h3>
              <p className="text-gray-600" data-id="element-319">
                Keep chemicals on the ground and reduce exposure in tight
                spaces.
              </p>
            </div>
          </div>
          <div className="flex items-start space-x-4 p-6 bg-brand-light rounded-lg border border-gray-200" data-id="element-320">
            <div className="flex-shrink-0" data-id="element-321">
              <div className="w-12 h-12 bg-brand-yellow/10 rounded-full flex items-center justify-center" data-id="element-322">
                <Clock className="h-6 w-6 text-brand-yellow" data-id="element-323" />
              </div>
            </div>
            <div data-id="element-324">
              <h3 className="text-xl font-bold text-brand-dark mb-2" data-id="element-325">
                Save Time
              </h3>
              <p className="text-gray-600" data-id="element-326">
                Faster setup, no pumping, no refilling, no downtime.
              </p>
            </div>
          </div>
          <div className="flex items-start space-x-4 p-6 bg-brand-light rounded-lg border border-gray-200" data-id="element-327">
            <div className="flex-shrink-0" data-id="element-328">
              <div className="w-12 h-12 bg-brand-yellow/10 rounded-full flex items-center justify-center" data-id="element-329">
                <TrendingDown className="h-6 w-6 text-brand-yellow" data-id="element-330" />
              </div>
            </div>
            <div data-id="element-331">
              <h3 className="text-xl font-bold text-brand-dark mb-2" data-id="element-332">
                Save Money
              </h3>
              <p className="text-gray-600" data-id="element-333">
                Fewer spills, less waste, and faster job completion.
              </p>
            </div>
          </div>

          {/* Bottom Row - Feature-Focused */}
          <div className="p-6 rounded-xl bg-brand-light border border-gray-100 text-center" data-id="element-334">
            <div className="w-16 h-16 bg-brand-yellow/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-335">
              <Zap className="h-8 w-8 text-brand-yellow" data-id="element-336" />
            </div>
            <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-337">
              Plug-and-Play Electric
            </h3>
            <p className="text-gray-600" data-id="element-338">
              No batteries to charge or fail. Consistent power all day long.
            </p>
          </div>
          <div className="p-6 rounded-xl bg-brand-light border border-gray-100 text-center" data-id="element-339">
            <div className="w-16 h-16 bg-brand-yellow/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-340">
              <Droplets className="h-8 w-8 text-brand-yellow" data-id="element-341" />
            </div>
            <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-342">
              75-Foot Hose
            </h3>
            <p className="text-gray-600" data-id="element-343">
              Reach further without moving your setup. Maximum mobility in tight
              spaces.
            </p>
          </div>
          <div className="p-6 rounded-xl bg-brand-light border border-gray-100 text-center" data-id="element-344">
            <div className="w-16 h-16 bg-brand-yellow/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-345">
              <Clock className="h-8 w-8 text-brand-yellow" data-id="element-346" />
            </div>
            <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-347">
              Faster Jobs
            </h3>
            <p className="text-gray-600" data-id="element-348">
              Less lifting. Less spills. Get in, spray, and get out faster.
            </p>
          </div>
        </div>

        {/* Automatic Pressure Control Section */}
        <div className="bg-brand-dark text-white p-8 rounded-xl border border-gray-700" data-id="element-349">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-350">
            <div className="flex-shrink-0" data-id="element-351">
              <div className="w-20 h-20 bg-brand-yellow/20 rounded-full flex items-center justify-center" data-id="element-352">
                <Gauge className="h-10 w-10 text-brand-yellow" data-id="element-353" />
              </div>
            </div>
            <div className="text-left" data-id="element-354">
              <h3 className="text-2xl font-bold text-brand-yellow mb-3" data-id="element-355">
                Automatic Pressure Control (60 PSI)
              </h3>
              <p className="text-gray-300 leading-relaxed max-w-3xl" data-id="element-356">
                The ForceX system automatically builds pressure up to 60 PSI and
                then shuts off. When the spray trigger is squeezed, pressure is
                released and the pump automatically reactivates to restore
                pressure on demand. This ensures consistent spray performance,
                prevents over-pressurization, and reduces wear on the system.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}